// Remove when this gets implemented: https://github.com/nuxt/nuxt/issues/23612
export default defineNuxtPlugin((nuxtApp) => {
  // Reload when a `chunkError` is thrown
  nuxtApp.hook('app:chunkError', () => reloadNuxtApp({ path: nuxtApp._route.path }))

  // Reload when the app manifest updates
  nuxtApp.hook('app:manifest:update', () => reloadNuxtApp({ path: nuxtApp._route.path }))
})
